export interface IDate2Utils {
  parseDate2(date2: string): { month: string; year: string };
  formatDate2Value(month: string, year: string): string;
}

const DATE2_LENGTH_WITH_MONTH = 6;
const DATE2_LENGTH_WITHOUT_MONTH = 4;

const Date2Utils = (): IDate2Utils => {
  return {
    parseDate2(date2: string) {
      let month;
      let year;

      if (date2?.length === DATE2_LENGTH_WITHOUT_MONTH) {
        year = date2;
      } else if (date2?.length === DATE2_LENGTH_WITH_MONTH) {
        month = date2.substr(0, 2);
        year = date2.substr(2, 5);
      }

      return {
        month,
        year
      };
    },

    formatDate2Value(month: string, year: string) {
      if (month?.length! === 0) {
        return `${month}${year}`;
      }
      return year;
    }
  };
};

export { Date2Utils };
